// English source strings are the keys (they are the reference UI text); Persian translations in locales/fa.json.
import { ref } from 'vue';
import fa from '@/locales/fa.json';

export type Lang = 'en' | 'fa';
export const lang = ref<Lang>('en');
const dicts: Record<Lang, Record<string, string>> = { en: {}, fa: fa as Record<string, string> };

/**
 * Translate a reference string; `{name}` placeholders are filled from params. A `||context` suffix keeps one English
 * word apart where Persian needs two (e.g. "Revoke||key" vs "Revoke" for a device); English drops the suffix.
 */
export function t(key: string, params?: Record<string, string | number>): string {
  let s = dicts[lang.value][key] ?? (key.includes('||') ? key.slice(0, key.indexOf('||')) : key);
  if (params) for (const [k, v] of Object.entries(params)) s = s.replace(new RegExp('\\{' + k + '\\}', 'g'), String(lang.value === 'fa' && typeof v === 'number' ? v.toLocaleString('fa-IR') : v));
  return s;
}

export function applyLang(l: Lang): void {
  lang.value = l;
  document.documentElement.lang = l;
  document.documentElement.dir = l === 'fa' ? 'rtl' : 'ltr';
}
